import { Navigate } from '@sorare/routing';

import { NBA_LEAGUES_LEAGUESLUG_LEADERBOARDS } from '@sorare/core/src/constants/__generated__/routes';

const Redirect = () => (
  <Navigate to={NBA_LEAGUES_LEAGUESLUG_LEADERBOARDS} keepParams replace />
);

export default Redirect;
